import React from 'react';
import { useTranslation } from 'react-i18next';
import { LanguageContainer } from '../LanguageContainer';

export const SettingsSecondColumn = () => {
  const { t } = useTranslation();
  return (
    <>
      <div data-cy="user-settings-language-container" className="mb-40">
        <h4 className="mb-26">{t('account.settings.language.title')}</h4>
        <LanguageContainer />
      </div>
    </>
  );
};
